import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow_up.svg'
import _imports_1 from '@/assets/img/arrow_down.svg'
import _imports_2 from '@/assets/img/bg3.png'


const _withScopeId = n => (_pushScopeId("data-v-b76de600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pros-email-thanks-page overflow-x-hide tw-bg-[#eeeff0]" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "col-sm-12 col-md-12 row my-auto no-padding no-margin" }
const _hoisted_4 = { class: "col-sm-12 col-12 col-md-12 row no-padding no-margin" }
const _hoisted_5 = { class: "col-sm-12 col-md-4 offset-md-2 text-container tab-container no-padding flex-container" }
const _hoisted_6 = { class: "left-sec align-center" }
const _hoisted_7 = { class: "left-sec1" }
const _hoisted_8 = { class: "left-sec2" }
const _hoisted_9 = {
  id: "psp-email-thank-verify-email",
  class: "verify-email"
}
const _hoisted_10 = { class: "left-sec3" }
const _hoisted_11 = { class: "left-sec-msg" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1
}
const _hoisted_14 = { class: "toggle-content" }
const _hoisted_15 = { class: "card-body-sec1" }
const _hoisted_16 = { class: "card-body-sec2" }
const _hoisted_17 = { class: "card-body-sec3" }
const _hoisted_18 = { class: "col-sm-12 col-md-6 tab-image-container flex-container no-padding" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "img-laptop img-mobile"
}, null, -1))
const _hoisted_20 = { class: "footer row d-sm-none d-md-block d-none d-sm-block page-footer no-margin" }
const _hoisted_21 = { href: "https://cybersystem.io" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerlogo = _resolveComponent("headerlogo")!
  const _component_brandpattern = _resolveComponent("brandpattern")!
  const _component_errorhandler = _resolveComponent("errorhandler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_headerlogo, { "page-type": '404' }),
      _createElementVNode("div", {
        class: "row no-padding main-body h-100",
        style: _normalizeStyle({ height: _ctx.windowHeight })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getUiText("app-prospect-email-thanks-heading-1")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.subHeading[0]) + " ", 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.prospectEmail), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.subHeading[1]), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getUiText("app-prospect-email-thanks-help-heading-1")), 1),
                  _createElementVNode("span", {
                    class: "left-sec-toggle",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowMore && _ctx.toggleShowMore(...args)))
                  }, [
                    (_ctx.canShowMore || null)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                      : (_openBlock(), _createElementBlock("img", _hoisted_13))
                  ]),
                  (_ctx.canShowMore || null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["", _ctx.canShowMore ? 'show' : ''])
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getUiText("app-prospect-email-thanks-help-text-1")), 1),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUiText(
                              'app-prospect-email-thanks-help-text-2',
                              true,
                            ), (item) => {
                                return (_openBlock(), _createElementBlock("li", { key: item }, " – " + _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickTryAgain && _ctx.onClickTryAgain(...args)))
                            }, _toDisplayString(_ctx.getUiText("app-prospect-email-thanks-link-action-1")), 1)
                          ])
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_brandpattern, {
                page: 'EMAILTHANKS',
                top: 0
              }),
              _hoisted_19
            ])
          ])
        ])
      ], 4),
      (_ctx.showProspectCallbackError || null)
        ? (_openBlock(), _createBlock(_component_errorhandler, {
            key: 0,
            "prospect-callback-error-msg": _ctx.prospectCallbackErrorMsg,
            onResetShowProspectCallbackError: _ctx.resetShowProspectCallbackError
          }, null, 8, ["prospect-callback-error-msg", "onResetShowProspectCallbackError"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createTextVNode(_toDisplayString(_ctx.getUiText("app-prospect-nav-cms-text-1")) + " ", 1),
        _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.getUiText("app-prospect-nav-cms-link-1")), 1)
      ])
    ])
  ]))
}